document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var navToggle = document.querySelector('[data-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (navToggle && mobileNav) {
    navToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
  }

  // Cart drawer
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartTriggers = document.querySelectorAll('[data-cart-open]');
  var cartClosers = document.querySelectorAll('[data-cart-close]');

  function openCart() { if (cartDrawer) cartDrawer.classList.add('is-open'); }
  function closeCart() { if (cartDrawer) cartDrawer.classList.remove('is-open'); }

  cartTriggers.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      openCart();
    });
  });
  cartClosers.forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      closeCart();
    });
  });

  // Add to cart via AJAX API, then open drawer and refresh drawer markup
  document.querySelectorAll('[data-add-to-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          refreshCartDrawer();
          openCart();
        })
        .catch(function (err) { console.error('Add to cart failed', err); });
    });
  });

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function refreshCartDrawer() {
    var container = document.querySelector('[data-cart-drawer-items]');
    if (!container) return;
    fetch('/cart?view=drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-items]');
        if (fresh) container.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  // Quantity selectors (product page + cart)
  document.querySelectorAll('[data-qty-selector]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    minus && minus.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    plus && plus.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  // Product gallery thumbnail swap
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-gallery-main]');
      if (main && thumb.dataset.fullSrc) main.src = thumb.dataset.fullSrc;
    });
  });

  // Ledger ticker: duplicate content for seamless infinite loop
  document.querySelectorAll('[data-ledger-track]').forEach(function (track) {
    track.innerHTML += track.innerHTML;
  });
});
